import type { ReactNode } from "react";

interface TopBarProps {
  title: string;
  meta?: ReactNode;
  actions?: ReactNode;
}

export function TopBar({ title, meta, actions }: TopBarProps) {
  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <h1 style={styles.title}>{title}</h1>
        {meta && <span style={styles.meta}>{meta}</span>}
      </div>
      {actions && <div style={styles.right}>{actions}</div>}
    </header>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--space-4)",
    height: 40,
    padding: "0 var(--page-pad-x)",
    borderBottom: "1px solid var(--comp-rule)",
    marginBottom: "var(--space-4)",
    background: "transparent",
  },
  left: {
    display: "flex",
    alignItems: "baseline",
    gap: "var(--space-3)",
    minWidth: 0,
  },
  title: {
    fontFamily: "var(--font-mono)",
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: 0,
    color: "var(--fg-1)",
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  meta: {
    fontFamily: "var(--font-mono)",
    fontSize: 11,
    color: "var(--fg-3)",
    whiteSpace: "nowrap",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
    flexShrink: 0,
  },
};
